export class ClientContract {
    constructor(public id: number, public title: string, public expired: number) { }
}

export interface IClientContractResponse {
    results: ClientContract[];
}
